var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSosMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47967",
    "data-name": "Group 47967",
    transform: "translate(0.646 0.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48015",
    "data-name": "Group 48015",
    transform: "translate(-0.394 -0.076)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1253",
    "data-name": "Ellipse 1253",
    cx: 35.5,
    cy: 35,
    rx: 35.5,
    ry: 35,
    transform: "translate(-0.252 -0.13)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("text", {
    id: "SOS",
    transform: "translate(35.748 41.87)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17,
    y: 0
  }, "SOS"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosMobileIcon);
export default __webpack_public_path__ + "static/media/SOSMobileIcon.df3ab93c8be079ab66bce5e1165448b7.svg";
export { ForwardRef as ReactComponent };